import React from 'react';

import './Tooltip.module.css';

const Tooltip = ({ children, title, type }) => {
  return (
    <div styleName={`tooltip ${type}`}>
      {title ? <span>{title}</span> : null}
      <div>
        <h4>{title}</h4>
        {children}
      </div>
    </div>
  );
};

export default Tooltip;
